import { useCallback, useContext, useEffect } from 'react';

import { useLazyGetBranchesForSystemQuery } from '@app/api/Branches';
import { useUserPrint } from '@app/hooks';
import type { UseBranchIndicatorsReportEffectsProps } from '@app/pages/Analytics/BranchIndicators/types';
import { DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';

export const useBranchIndicatorsReportEffects = ({
  setAllBranches,
  handleSearchData,
}: UseBranchIndicatorsReportEffectsProps) => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const { showNotification } = useContext(NotificationContext);

  const [getBranchesForSystem] = useLazyGetBranchesForSystemQuery();

  useEffect(() => {
    handleSearchData({
      ...DEFAULT_FILTERS_DATA,
      branchIds: null,
    });
  }, [handleSearchData]);

  const getBranchesForSystemHandler = useCallback(async () => {
    try {
      const allBranches = await getBranchesForSystem({
        ActiveBranchId,
      }).unwrap();
      const adaptedBranches = allBranches.map(({ Id, Name }) => {
        return {
          value: Id,
          label: Name,
        };
      });
      setAllBranches(adaptedBranches);
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  }, [ActiveBranchId, getBranchesForSystem, setAllBranches, showNotification]);

  useEffect(() => {
    getBranchesForSystemHandler();
  }, [getBranchesForSystemHandler]);
};
